import { Component, OnInit, OnDestroy } from '@angular/core';
import { GeneralService } from 'src/app/services/general/general.service';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogComponent } from 'src/app/components/confirm-dialog/confirm-dialog.component';
import { ShowInfoStudentsDialogComponent } from 'src/app/components/show-info-students-dialog/show-info-students-dialog.component';
import { DatePipe } from '@angular/common';
import { DateTime, Zone } from 'luxon';
@Component({
  selector: 'app-index',
  templateUrl: './index.component.html',
  styleUrls: ['./index.component.scss']
})
export class IndexComponent implements OnInit {

  public classes_list:any;
  public loading = true;  
  public currency:any;
  public user: any;
  public userInfo: any;
  public show:any;
  public today:any;
  currentLocale: string | null;

  constructor(
    public general: GeneralService,
    private dialog: MatDialog, 
    public datepipe : DatePipe
  ) {

    this.currentLocale = this.general.getCurrentLocale();
    if(!localStorage.getItem("currency")) {
      localStorage.setItem('currency', "eur");
    }
    
    this.currency = localStorage.getItem('currency');
    window.addEventListener('currency_change', () => {
      this.currency = localStorage.getItem('currency');
    }, false);
  }

  async ngOnInit() {
    try {
      this.today = new Date() ;
      this.today =  this.datepipe.transform(this.today, 'yyyy-MM-dd');
      this.loading = true;
      await this.getUserInfo();
      await this.loadInitalData();
      await this.loadGrupalList("1");
    } catch (error) {
      console.log(error);
    } finally {
      this.loading = false;
    }
  }

  async getUserInfo() {
    const response = await this.general.getUserInfo();
    this.userInfo = response.data;
    this.user = this.userInfo.user;
  }

  async loadInitalData() {
  }

  async loadGrupalList(show:any) {
    const request = this.general.httpPost("groupal-class-list", {
      show: show,
    });   
    const response: any = await this.general.forkJoin(request);
    this.classes_list = response[0].message;

    this.classes_list = this.classes_list.map((e: any) => {
      const timezone = this.general.getCurrentTimezone();
      e.date = DateTime.fromFormat(e.dateHour,'yyyy-LL-dd HH:mm:ss',{zone: 'UTC',}).setZone(timezone);
      e.date = e.date.setLocale(this.currentLocale).toFormat('dd/MM/yyyy');
      e.hour = DateTime.fromFormat(e.dateHour,'yyyy-LL-dd HH:mm:ss',{zone: 'UTC',}).setZone(timezone);
      e.hour = e.hour.setLocale(this.currentLocale).toFormat('HH:mm');
      return e;
      });

    this.show = show;
  }
  
  editClass(id: any) {
    this.general.navigate(`/teacher/group-classes/edit/${id}`);
  }

  sureRemoveClass(id: any) {
    const removeDialogRef = this.dialog.open(ConfirmDialogComponent, {
      data: {
        title: 'sure_delele_groupal_class',
      },
      autoFocus: false,
    });

    const subscribed = removeDialogRef.afterClosed().subscribe((response) => {
      subscribed.unsubscribe();

      if (!response) {
        return;
      }else{
        this.removeClass(id);
      }
      
    });
  }

  async removeClass(id: any) {
    try {
      let response = await this.general.httpPost('groupal-class-delete', {
        user_id: this.user.id,
        groupal_class_id: id
      });
  
      if(response){
        await this.general.sleep(200);
        this.general.showSuccess('data-saved-successfully');
        this.loadInitalData();
      }
    } catch (error) {
      this.general.showErrorForm(error);
    }
  }

}
